import { CloseCircleOutlined } from "@ant-design/icons";
import React from "react";
import Button from "./LabelCustomizer/Button";
import templates from "../templates.json";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import './ThemePicker.scss'


const ThemePicker = ({ productID, showCustomizer, cancel, setUseTemplate, inLabelCustomizer, handleTemplate, display, setShowTemplate, showTemplate }) => {
  const allCategories = templates.map((item) => item.category);
  const categoryNames = [...new Set(allCategories)];

  const getTemplateByName = (category) => {
    return templates.filter((template) => template.category === category);
  };
  const themeHandler = (item) => {
  if (!inLabelCustomizer) {
    showCustomizer(productID);
    setUseTemplate(item.src);
  } else {
   handleTemplate(item.src)}
  }
  return (
    <section className="theme-picker-container">
      {/* <h1 className="theme-picker-title">Change your template</h1> */}
      <Accordion className="accordion-theme-picker" allowZeroExpanded>
        {categoryNames.map((item) => (
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>{item}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="templates">
                {getTemplateByName(item).map((item) => (
                  <div 
                  className="template"
                  onClick={() => {
                    themeHandler(item);
                    console.log(`running tired` )
                    // if (display === "mobile") setShowTemplate(!showTemplate);
                  }}
                  key={item.id}
                  >
                    <p>{item.name}</p>
                    <img src={item.src} alt={item.name} />
                  </div>
                ))}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>

    </section>
  );
};

export default ThemePicker;
